export default "__VITE_ASSET__25938bec__"